module.exports = __webpack_public_path__ + "static/media/Creation_26-FB.2ede26e8.jpg";